import $ from 'jquery';
import { duplicateTemplate } from '~loader/loader-api/duplicateTemplate';
import { handleTabTemplates } from '~src/sidebar/index';

export const duplicateTemplateClickHandler = async (event) => {
  event.preventDefault();
  event.stopPropagation();

  const templateId = $(event.currentTarget).attr(
    'data-giotto-duplicate-template'
  );

  await duplicateTemplate(templateId);
  await handleTabTemplates(true);
};
